import { useEffect } from "react";
import { projectsData } from "../static/data";
import { useParams, Link } from "react-router-dom";
import { ProjectDetailContent } from "../components";

const normalizeProjectKey = (value = "") =>
  decodeURIComponent(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const ProjectDetail = () => {
  const { title } = useParams();
  const normalizedTitle = normalizeProjectKey(title);

  const project = projectsData.find(
    (p) =>
      normalizeProjectKey(p.title) === normalizedTitle ||
      normalizeProjectKey(p.title.split(":")[0].trim()) === normalizedTitle,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  if (!project) {
    return (
      <section className="pd pd__not-found">
        <div className="pd__container">
          <div className="project-not-found">
            <span className="project-not-found__badge">404</span>
            <h1>This case study is unavailable</h1>
            <p>
              The link may be outdated or typed incorrectly. Explore available
              projects below or return to the homepage.
            </p>

            <div className="project-not-found__list">
              {projectsData.map((item) => (
                <Link
                  key={item.id}
                  to={`/projects/${encodeURIComponent(item.title)}`}
                  className="project-not-found__item"
                >
                  {item.title}
                </Link>
              ))}
            </div>

            <div className="project-not-found__actions">
              <Link to="/" className="pd__btn pd__btn-primary">
                Back to Homepage
              </Link>
              <a
                href="https://cal.com/ahadali/lets-engineer-your-bespoke-product?overlayCalendar=true&layout=month_view"
                target="_blank"
                rel="noreferrer"
                className="pd__btn pd__btn-outline"
              >
                Book 1-1 Meeting
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="pd__page-wrapper">
      <ProjectDetailContent project={project} />
    </div>
  );
};

export default ProjectDetail;
